export default {
  path: '/expert-mode-extractor',
  component: () =>
    import(
      '@/components/pages/ExpertModeExtractors/ExpertModeExtractor.vue'
    )
}
